import { Controller } from '@hotwired/stimulus'

// IMPORTANT NOTE FROM MDN about window.navigator.online:
// > Note: It is important to note that this event and attribute are inherently unreliable.
// > A computer can be connected to a network without having Internet access.
//
// However, in our case it doesn't effect our UX. We're only notifying users
// when they *don't* have a network connection, which means they definitely don't have internet access.
// We don't expect users to rely on the notification to know when they *do* have internet access.
export default class extends Controller {

  initialize(){
    if(!window.navigator.onLine) {
      this.onOffline()
    } else {
      this.onOnline()
    }
  }

  onOnline(){
    this.hideBanner()
  }

  onOffline(){
    this.showBanner()
  }

  showBanner(){
    this.element.classList.remove("hidden")
  }

  hideBanner(){
    this.element.classList.add("hidden")
  }
}
